import React from 'react';

import { useWaypointTemplateQuery } from '@dashboard/generated/wp/platform';
import { Skeleton } from '@mui/material';

type Props = {
  templateId: string | null | undefined;
};

export default function TemplateName({ templateId }: Props) {
  const { data } = useWaypointTemplateQuery({
    variables: { id: templateId ?? '' },
    skip: templateId === null,
  });
  if (templateId === null) {
    return <>Quick message</>;
  }
  const model = data?.WaypointTemplate;
  if (model === undefined) {
    return <Skeleton />;
  }
  return <>{model.name}</>;
}
